<div class="alarm-ringing">
  <div class="alarm-ringing__background"></div>

  <div class="alarm-ringing__content">
    <div class="alarm-ringing__icon">
      <mat-icon>&#xe855;</mat-icon>
    </div>

    <div class="alarm-ringing__time">
      <div class="alarm-time">{{ formattedTime }}</div>
      <div class="alarm-date">{{ formattedDate }}</div>
    </div>

    <div class="alarm-ringing__message">
      <h2 class="alarm-title">{{ 'PAGES.ALARM_RINGING.TITLE' | translate }}</h2>
      <p class="alarm-subtitle">{{ 'PAGES.ALARM_RINGING.SUBTITLE' | translate }}</p>
    </div>

    <div class="alarm-ringing__actions">
      <button mat-raised-button class="stop-button htv-selectable htv-focus" (click)="stopAlarm()">
        <mat-icon>&#xe047;</mat-icon>
        <span>{{ 'PAGES.ALARM_RINGING.STOP' | translate }}</span>
      </button>
    </div>

    <div class="pulse-animation">
      <div class="pulse-circle pulse-circle--1"></div>
      <div class="pulse-circle pulse-circle--2"></div>
      <div class="pulse-circle pulse-circle--3"></div>
    </div>
  </div>
</div>
